import React from "react";
import classnames from "classnames";
import "./AppCheckbox.css";

interface AppCheckboxProps {
  children: React.ReactNode;
  name: string;
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string | number | readonly string[] | undefined;
  secondary?: boolean;
  wide?: boolean;
  nohover?: boolean;
  error?: boolean;
}

export default function AppCheckbox({
  children,
  name,
  checked,
  onChange,
  value,
  secondary = false,
  wide = false,
  nohover,
  error,
}: AppCheckboxProps) {
  return (
    <label
      className={classnames("app-checkbox", {
        "app-checkbox--secondary": secondary,
        "app-checkbox--checked": checked,
        "app-checkbox--wide": wide,
        "app-checkbox--selected": checked && wide,
        "app-checkbox--no-hover": nohover,
        "app-checkbox--error": error,
      })}
    >
      {secondary ? (
        <>
          <span className="app-checkbox__box" />
          <span className="app-checkbox__title">{children}</span>
        </>
      ) : (
        <>
          <span className="app-checkbox__title">{children}</span>
          {!wide && <span className="app-checkbox__box" />}
        </>
      )}
      <input
        name={name}
        checked={checked}
        onChange={onChange}
        type="checkbox"
        value={value}
        className="app-checkbox__input"
      />
    </label>
  );
}
